<script setup lang="ts"></script>
<template>
  <div class="h-full max-w-[100vw] grow shrink p-4 lg:px-9 lg:pt-6 overflow-y-auto overflow-x-hidden">
    <slot />
  </div>
</template>
